/**
* Copyright Zendesk, Inc.
*
* Use of this source code is governed under the Apache License, Version 2.0
* found at http://www.apache.org/licenses/LICENSE-2.0.
*/
import styled from 'styled-components';
import React__default, { Children } from 'react';
import { retrieveComponentStyles, DEFAULT_THEME } from '@zendeskgarden/react-theming';
import SvgAlertErrorStroke from '../../node_modules/@zendeskgarden/svg-icons/src/16/alert-error-stroke.svg.js';
import SvgAlertWarningStroke from '../../node_modules/@zendeskgarden/svg-icons/src/16/alert-warning-stroke.svg.js';
import SvgCheckCircleStroke from '../../node_modules/@zendeskgarden/svg-icons/src/16/check-circle-stroke.svg.js';

const MessageIcon = _ref => {
  let {
    children,
    validation,
    ...props
  } = _ref;
  let retVal;
  if (validation === 'error') {
    retVal = React__default.createElement(SvgAlertErrorStroke, props);
  } else if (validation === 'success') {
    retVal = React__default.createElement(SvgCheckCircleStroke, props);
  } else if (validation === 'warning') {
    retVal = React__default.createElement(SvgAlertWarningStroke, props);
  } else {
    retVal = React__default.cloneElement(Children.only(children));
  }
  return retVal;
};
const COMPONENT_ID = 'forms.input_message_icon';
const StyledMessageIcon = styled(MessageIcon).attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': '8.76.9',
  'aria-hidden': null,
  role: 'img'
}).withConfig({
  displayName: "StyledMessageIcon",
  componentId: "sc-1ph2gba-0"
})(["width:", ";height:", ";", ";"], props => props.theme.iconSizes.md, props => props.theme.iconSizes.md, props => retrieveComponentStyles(COMPONENT_ID, props));
StyledMessageIcon.defaultProps = {
  theme: DEFAULT_THEME
};

export { StyledMessageIcon };
